import { Form, Modal, message, Typography } from 'antd'

import { useTranslation } from 'react-i18next'

import { API } from '../../lib/api'
import { useLoading } from '../../lib/hooks/useLoading'
import { SupportFormValues } from '../Forms'
import { SupportMessage } from '../Forms/SupportMessage'
import { ModalProps } from './types'

export function EmailSupport({ isVisible, onCancel }: ModalProps): React.ReactNode {
  const { t } = useTranslation()
  const [isLoading, withLoading] = useLoading()

  const handleSubmit = async (formValues: SupportFormValues): Promise<void> => {
    const formMessage = formValues.message.trim()
    if (!formMessage) return
    const success = await withLoading(API.submitSupportMessage({ message: formMessage }))
    if (success) {
      message.success(t('message.supportRequest'))
      onCancel()
    }
  }

  return (
    <Modal
      open={isVisible}
      onCancel={onCancel}
      title={t('menus.help.emailSupportModal.subTitle')}
      footer={null}
      destroyOnHidden
      centered
    >
      <Typography.Paragraph>
        {t('menus.help.emailSupportModal.emailText')}{' '}
        <Typography.Link href="mailto:support@alveris.com" data-i18n-ignore>
          support@alveris.com
        </Typography.Link>{' '}
        {t('menus.help.emailSupportModal.supportMessageText')}
      </Typography.Paragraph>
      <Form onFinish={handleSubmit}>
        <SupportMessage loading={isLoading} />
      </Form>
    </Modal>
  )
}
